// extracted by mini-css-extract-plugin
export default {"modal_header":"LearnMoreModal_modal_header__veRWJ","modal_background":"LearnMoreModal_modal_background__vXoB0"};